ikart.webshop.product_ui.attr = function(value) {
	return String(value ?? "")
		.replace(/&/g, "&amp;")
		.replace(/"/g, "&quot;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;");
};

ikart.webshop.product_ui.get_brand_filter_url = function(brand) {
	brand = String(brand || "").trim();
	if (!brand) {
		return "";
	}
	return "/all-products?field_filters=" + encodeURIComponent(JSON.stringify({ brand: [brand] }));
};

ikart.webshop.product_ui.get_brand_html = function(item) {
	const attr = ikart.webshop.product_ui.attr;
	const brand = String(item.brand || "").trim();
	// leave the row blank (but present, for consistent card height) when the
	// item has no brand — do NOT fall back to category/item group.
	if (!brand) {
		return `<div class="product-category product-brand-empty"></div>`;
	}
	const href = ikart.webshop.product_ui.get_brand_filter_url(brand);
	return `
		<div class="product-category product-brand">
			<a class="product-brand-link" href="${ attr(href) }" itemprop="brand">${ attr(brand) }</a>
		</div>
	`;
};

ikart.webshop.product_ui.format_money = function(value, currency) {
	if (!Number.isFinite(value)) {
		return "";
	}

	if (typeof format_currency === "function") {
		return format_currency(value, currency);
	}

	return `${currency || ""} ${value.toFixed(2)}`.trim();
};

ikart.webshop.product_ui.get_group_variant_attrs = function(variant) {
	const attr = ikart.webshop.product_ui.attr;
	return `
		data-item-code="${attr(variant.item_code)}"
		data-in-cart="${variant.in_cart ? 1 : 0}"
		data-cart-qty="${attr(variant.cart_qty || "")}"
		data-display-rate="${attr(variant.display_rate || "")}"
		data-currency="${attr(variant.currency || "")}"
		data-formatted-price="${attr(variant.formatted_price || "")}"
		data-gst-inclusive-price="${attr(variant.gst_inclusive_price || "")}"
		data-formatted-gst-inclusive-price="${attr(variant.formatted_gst_inclusive_price || "")}"
		data-formatted-gst-rate="${attr(variant.formatted_gst_rate || "")}"
		data-gst-label="${attr(variant.gst_label || __("GST"))}"
		data-stock-uom="${attr(variant.stock_uom || "")}"
		data-order-uom="${attr(variant.order_uom || "")}"
		data-conversion-factor="${attr(variant.conversion_factor || 1)}"
		data-use-alternate-order-uom="${variant.use_alternate_order_uom ? 1 : 0}"
		data-has-price="${variant.formatted_price ? 1 : 0}"
		data-route="${attr(variant.route || "")}"
		data-image="${attr(variant.image || "")}"
		data-title="${attr(variant.web_item_name || variant.item_code || "")}"
	`;
};

ikart.webshop.product_ui.get_qty_for_scope = function($scope) {
	const $qty_input = $scope.find('.product-qty-input').first();
	let qty = Number.parseFloat($qty_input.val());

	if (!Number.isFinite(qty) || qty <= 0) {
		qty = 1;
	}

	return qty;
};

ikart.webshop.product_ui.get_qty_multiplier = function(source) {
	if (!source || cint(source.useAlternateOrderUom) !== 1) {
		return 1;
	}

	const conversion_factor = Number.parseFloat(source.conversionFactor);
	return Number.isFinite(conversion_factor) && conversion_factor > 0 ? conversion_factor : 1;
};

ikart.webshop.product_ui.get_qty_label = function(item) {
	// Multiple order-UOM options: the <select> beside the field shows the
	// unit, so the label stays a plain "Qty".
	if ((item.order_uom_options || []).length > 1) {
		return __("Qty");
	}

	// Otherwise always surface the unit: the alternate order UOM (e.g. Box)
	// when set, else the stock UOM (e.g. Nos).
	const uom = (cint(item.use_alternate_order_uom) === 1 && item.order_uom)
		? item.order_uom
		: (item.stock_uom || item.uom || "");

	return uom ? `${__("Qty")} (${uom})` : __("Qty");
};

ikart.webshop.product_ui.format_qty = function(value) {
	if (!Number.isFinite(value)) {
		return "";
	}

	return Number.isInteger(value) ? String(value) : String(Number(value.toFixed(3)));
};

ikart.webshop.product_ui.get_cart_indicator_text = function(qty, order_uom, use_alternate_order_uom) {
	if (cint(use_alternate_order_uom) === 1 && order_uom) {
		return `${qty} ${order_uom}`;
	}

	return qty;
};

// Add-to-cart popup. The cards no longer carry an inline qty box: the cart
// button opens this instead, so the quantity is chosen in one obvious place
// rather than in a field that was easy to miss on a dense grid.
//
// Deliberately dependency-free. frappe.ui.Dialog would be the obvious choice,
// but dialog.bundle.js is only loaded on the item, cart and review pages — not
// on the listing pages where this is used — so it builds its own overlay,
// following the same conventions as .product-image-preview-overlay.
ikart.webshop.product_ui.close_add_to_cart_popup = function() {
	const $overlay = $('.imek-atc-overlay');
	if (!$overlay.length) {
		return;
	}
	$overlay.remove();
	$(document).off('keydown.imekAtc');
	$('body').removeClass('imek-atc-open');
};

ikart.webshop.product_ui.open_add_to_cart_popup = function(opts) {
	const attr = ikart.webshop.product_ui.attr;
	ikart.webshop.product_ui.close_add_to_cart_popup();

	// $scope is the card. Everything the popup shows is read from it, and every
	// option click is forwarded back into it, so the card stays the single
	// source of truth for which variant is selected and what it costs.
	const $scope = opts.$scope;
	const $card_options = $scope.find('.product-size-option');

	const options_html = $card_options.length
		? `
			<div class="imek-atc-options">
				${ $card_options.toArray().map((el) => {
					const $el = $(el);
					return `<button type="button" class="imek-atc-option ${ $el.hasClass('active') ? 'active' : '' }"
						data-item-code="${ attr($el.data('item-code')) }">${ $el.text().trim() }</button>`;
				}).join("") }
			</div>
		`
		: "";

	const $overlay = $(`
		<div class="imek-atc-overlay" role="dialog" aria-modal="true"
			aria-label="${ __("Add to cart") }">
			<div class="imek-atc-card">
				<button type="button" class="imek-atc-close" aria-label="${ __("Close") }">&times;</button>
				<div class="imek-atc-media">
					<img class="imek-atc-image" src="" alt="">
					<div class="imek-atc-scheme"></div>
				</div>
				<h3 class="imek-atc-title"></h3>
				<p class="imek-atc-brand"></p>
				${ options_html }
				<div class="imek-atc-pricebox"></div>
				<label class="imek-atc-label" for="imek-atc-qty">${ __("Quantity") }</label>
				<div class="imek-atc-qtyrow">
					<button type="button" class="imek-atc-step" data-step="-1"
						aria-label="${ __("Decrease quantity") }">&minus;</button>
					<!-- Ships BLANK and stays blank, like every other qty box in the
					     app (see the contract at the top of qty_stepper.html):
					     blank means 1 on add. read_qty() below resolves it, so
					     the field never has to show a number the buyer did not
					     type. -->
					<input id="imek-atc-qty" class="imek-atc-qty" type="number"
						inputmode="decimal" min="1" step="any" value=""
						aria-label="${ __("Quantity") }">
					<button type="button" class="imek-atc-step" data-step="1"
						aria-label="${ __("Increase quantity") }">+</button>
					<span class="imek-atc-uom"></span>
				</div>
				<button type="button" class="btn btn-sm btn-primary imek-atc-confirm">
					${ opts.add_label }
				</button>
			</div>
		</div>
	`);

	// Mirror whatever the card currently says. Called again after every option
	// click, once the card has updated itself.
	const sync_from_card = () => {
		const $price = $scope.find('.product-price').first();
		const title = ($scope.find('.product-title').first().text() || "").trim();
		const unit = ($price.find('.product-unit-price').first().text() || "").trim();
		const uom = ($price.find('.product-stock-uom').first().text() || "").trim();
		const $gst = $price.find('.product-gst-inclusive-row').first();

		$overlay.find('.imek-atc-title').text(title);
		$overlay.find('.imek-atc-uom').text(
			($price.data('order-uom') || $price.data('stock-uom') || "").toString()
		);

		let price_html = `<span class="imek-atc-price">${ attr(unit) }</span>`;
		if (uom) {
			price_html += ` <span class="imek-atc-priceuom">${ attr(uom) }</span>`;
		}

		// MRP + savings, when the item carries them. Read from the card's price
		// block so they follow the selected option like everything else.
		const mrp = ($price.find('.striked-price').first().text() || "").trim();
		const off = ($price.find('.product-info-green').first().text() || "").trim();
		if (mrp) {
			price_html += ` <span class="imek-atc-mrp"><s>${ attr(mrp) }</s></span>`;
		}
		if (off) {
			price_html += ` <span class="imek-atc-off">${ attr(off) }</span>`;
		}

		if ($gst.length && !$gst.hasClass('hidden')) {
			price_html += `<div class="imek-atc-gst">${ $gst.text().replace(/\s+/g, " ").trim() }</div>`;
		}
		$overlay.find('.imek-atc-pricebox').html(price_html);

		$overlay.find('.imek-atc-brand').text(
			($scope.find('.product-brand, .imek-card-brand').first().text() || "").trim()
		);

		// the scheme badge (e.g. a group offer) rides along on the card
		const $scheme = $scope.find('.imek-scheme-badge').first();
		$overlay.find('.imek-atc-scheme').html($scheme.length ? $scheme.html() : "")
			.toggleClass('hidden', !$scheme.length);

		// variant image if one is selected, otherwise the card's own photo
		const $active = $scope.find('.product-size-option.active').first();
		const img = ($active.length && $active.data('image'))
			|| $scope.find('.card-img').first().attr('src')
			|| "";
		$overlay.find('.imek-atc-image')
			.attr('src', img)
			.attr('alt', title)
			.toggleClass('hidden', !img);
	};

	$('body').addClass('imek-atc-open').append($overlay);
	sync_from_card();

	const $qty = $overlay.find('.imek-atc-qty');
	setTimeout(() => $qty.trigger('focus').trigger('select'), 30);

	const read_qty = () => {
		const value = Number.parseFloat($qty.val());
		return Number.isFinite(value) && value > 0 ? value : 1;
	};

	// Forward to the card's own (hidden) option button so the existing
	// delegated handler recalculates price, image and in-cart state exactly as
	// it always has, then re-read the result.
	$overlay.on('click', '.imek-atc-option', function() {
		const item_code = $(this).attr('data-item-code');
		$overlay.find('.imek-atc-option').removeClass('active');
		$(this).addClass('active');
		ikart.webshop.product_ui._suppress_card_image = true;
		try {
			$card_options
				.filter((_i, el) => String($(el).data('item-code')) === String(item_code))
				.first()
				.trigger('click');
		} finally {
			ikart.webshop.product_ui._suppress_card_image = false;
		}
		setTimeout(sync_from_card, 0);
	});

	$overlay.on('click', '.imek-atc-step', function() {
		const step = Number.parseFloat($(this).attr('data-step')) || 0;
		$qty.val(Math.max(1, read_qty() + step));
	});

	const dismiss = () => ikart.webshop.product_ui.close_add_to_cart_popup();
	$overlay.on('click', '.imek-atc-close', dismiss);
	$overlay.on('click', (e) => {
		if (e.target === $overlay[0]) {
			dismiss();
		}
	});
	$(document).on('keydown.imekAtc', (e) => {
		if (e.key === 'Escape') {
			dismiss();
		}
	});

	const confirm = () => {
		const qty = read_qty();
		dismiss();
		opts.on_confirm(qty);
	};
	$overlay.on('click', '.imek-atc-confirm', confirm);
	$qty.on('keydown', (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			confirm();
		}
	});
};

// THE qty stepper — single JS source of truth for every client-rendered qty
// box (webshop grid/list cards AND marketplace cards, which call this from
// marketplace_public.js). The Jinja twin for server-rendered templates is
// templates/includes/qty_stepper.html — keep the two in sync.
// Contract: ships BLANK (blank = qty 1 on add), UOM rides inside as a
// right-hand tag or the order-UOM picker; hook classes are load-bearing
// (webshop: .product-qty-wrapper/.product-qty-input; marketplace:
// [data-mkt-qty]/[data-mkt-qty-input]).
ikart.webshop.product_ui.qty_stepper_html = function(opts) {
	opts = opts || {};
	const attr = ikart.webshop.product_ui.attr;
	const wrapper_classes = [
		"imek-qty-stepper",
		opts.webshop ? "product-qty-wrapper" : "",
		opts.large ? "imek-qty-stepper-lg" : "",
		opts.extra_class || "",
		opts.hidden ? "hidden" : "",
	].filter(Boolean).join(" ");
	const input = opts.webshop
		? `<input class="imek-qty-value product-qty-input" type="number" inputmode="decimal" min="1" step="any" value="" data-item-code="${ attr(opts.item_code || "") }" aria-label="${ __("Quantity") }">`
		: `<input class="imek-qty-value" data-mkt-qty-input type="number" inputmode="decimal" min="1" step="any" value="" aria-label="${ __("Quantity") }">`;
	const tag = opts.uom_select_html
		|| (opts.uom ? `<span class="imek-qty-uom">${ attr(opts.uom) }</span>` : "");
	return `<div class="${ wrapper_classes }"${ opts.webshop ? "" : " data-mkt-qty" }>${ input }${ tag }</div>`;
};

// Webshop card wrapper around the shared stepper: resolves the display UOM
// (or the multi-UOM picker) from the product row and hides the control while
// the item is in the cart.
ikart.webshop.product_ui.get_marketplace_qty_selector = function(item, extra_class) {
	const options = item.order_uom_options || [];
	let uom = "";
	let uom_select_html = "";
	if (options.length > 1) {
		uom_select_html = ikart.webshop.product_ui.get_uom_select_html(item);
	} else {
		uom = (cint(item.use_alternate_order_uom) === 1 && item.order_uom)
			? item.order_uom
			: (item.stock_uom || item.uom || "");
	}
	return ikart.webshop.product_ui.qty_stepper_html({
		webshop: true,
		item_code: item.item_code,
		uom: uom,
		uom_select_html: uom_select_html,
		extra_class: extra_class,
		hidden: !!item.in_cart,
	});
};

ikart.webshop.product_ui.get_uom_select_html = function(item) {
	const options = item.order_uom_options || [];
	if (options.length <= 1) {
		return "";
	}

	const selected_uom = item.order_uom || (options[0] && options[0].uom) || "";
	const attr = ikart.webshop.product_ui.attr;
	return `
		<select class="form-control product-uom-select" aria-label="${ __("Order UOM") }">
			${options.map(option => `
				<option value="${ attr(option.uom) }"
					data-conversion-factor="${ attr(option.conversion_factor || 1) }"
					${option.uom === selected_uom ? "selected" : ""}>
					${option.uom}
				</option>
			`).join("")}
		</select>
	`;
};

ikart.webshop.product_ui.replace_broken_product_images = function(root = document) {
	root.querySelectorAll(".card-img").forEach((img) => {
		const replace = () => {
			const container = img.closest(".card-img-container");
			if (!container || container.dataset.imageFallbackApplied) {
				return;
			}

			container.dataset.imageFallbackApplied = "1";
			const fallback_text = container.dataset.fallbackText || "";
			container.innerHTML = `<div class="card-img-top no-image">${fallback_text}</div>`;
		};

		img.addEventListener("error", replace, {once: true});
		if (img.complete && !img.naturalWidth) {
			replace();
		}
	});
};

ikart.webshop.product_ui.get_image_preview_button_html = function(image, title, image_class) {
	const attr = ikart.webshop.product_ui.attr;
	const is_list_image = String(image_class || "").includes("website-image");
	return `
		<button type="button" class="product-image-preview-trigger ${ is_list_image ? "product-list-link" : "" }"
			data-image-src="${ attr(image) }"
			data-image-alt="${ attr(title) }">
			<img itemprop="image" class="${ image_class }"
				src="${ attr(image) }"
				alt="${ attr(title) }"
				loading="lazy" decoding="async">
		</button>
	`;
};

ikart.webshop.product_ui.update_product_image = function($scope, image, title, item_code) {
	// Options are chosen in the popup now, and the popup forwards the click to
	// the card's hidden option to reuse the existing machinery. Swapping the
	// card's photo as a side effect of that made the grid flicker behind the
	// dialog for a choice the customer had not committed to yet -- the popup
	// shows the variant image instead.
	if (ikart.webshop.product_ui._suppress_card_image) {
		return;
	}
	const attr = ikart.webshop.product_ui.attr;
	const image_alt = title || item_code || "";
	const fallback_text = attr(frappe.get_abbr(image_alt || ""));
	const $grid_container = $scope.find('.card-img-container').first();
	const $list_container = $scope.find('.list-image').first();

	if ($grid_container.length) {
		$grid_container.attr('data-fallback-text', fallback_text).removeAttr('data-image-fallback-applied');
		if (image) {
			const $trigger = $grid_container.find('.product-image-preview-trigger').first();
			if ($trigger.length) {
				$trigger
					.attr('data-image-src', image)
					.attr('data-image-alt', image_alt)
					.data('image-src', image)
					.data('image-alt', image_alt);
				$trigger.find('.card-img')
					.attr('src', image)
					.attr('alt', image_alt);
			} else {
				$grid_container.html(
					ikart.webshop.product_ui.get_image_preview_button_html(image, image_alt, "card-img")
				);
			}
		} else {
			$grid_container.html(`<div class="card-img-top no-image">${ fallback_text }</div>`);
		}
	}

	if ($list_container.length) {
		if (image) {
			const $trigger = $list_container.find('.product-image-preview-trigger').first();
			if ($trigger.length) {
				$trigger
					.attr('data-image-src', image)
					.attr('data-image-alt', image_alt)
					.data('image-src', image)
					.data('image-alt', image_alt);
				$trigger.find('.website-image')
					.attr('src', image)
					.attr('alt', image_alt);
			} else {
				const image_html = ikart.webshop.product_ui.get_image_preview_button_html(
					image,
					image_alt,
					"website-image h-100 w-100"
				);
				const $fallback = $list_container.find('.no-image-list').first();
				if ($fallback.length) {
					$fallback.replaceWith(image_html);
				} else {
					$list_container.prepend(image_html);
				}
			}
		} else {
			$list_container.find('.product-image-preview-trigger').remove();
			if (!$list_container.find('.no-image-list').length) {
				$list_container.prepend(`<div class="card-img-top no-image-list">${ fallback_text }</div>`);
			}
		}
	}
};

ikart.webshop.product_ui.has_entered_qty = function($scope) {
	const $qty_input = $scope.find('.product-qty-input').first();
	const qty = Number.parseFloat($qty_input.val());
	return Number.isFinite(qty) && qty > 0;
};

ikart.webshop.product_ui.update_product_price = function($scope) {
	const $price = $scope.find('.product-price').first();
	if (!$price.length) {
		return;
	}

	const $variant = $scope.find('.product-size-option.active').first();
	const source = $variant.length ? $variant.data() : $price.data();
	const formatted_price = source.formattedPrice || $price.data('formatted-price') || "";
	const formatted_gst_inclusive_price = source.formattedGstInclusivePrice || "";
	const formatted_gst_rate = source.formattedGstRate || "";
	const display_rate = Number.parseFloat(source.displayRate);
	const gst_inclusive_price = Number.parseFloat(source.gstInclusivePrice);
	const currency = source.currency || $price.data('currency') || "";
	const qty = ikart.webshop.product_ui.get_qty_for_scope($scope);
	const qty_multiplier = ikart.webshop.product_ui.get_qty_multiplier(source);
	const stock_qty = qty * qty_multiplier;
	const has_entered_qty = ikart.webshop.product_ui.has_entered_qty($scope);
	const stock_uom = source.stockUom || "";
	const order_uom = source.orderUom || stock_uom;

	$price.find('.product-unit-price').html(formatted_price || __("Price on request"));
	// no unit suffix without a price — "Price on request / Nos" reads wrong
	$price.find('.product-stock-uom').text(formatted_price && stock_uom ? `/ ${stock_uom}` : "");

	$price.find('.product-gst-inclusive-row').toggleClass('hidden', !formatted_gst_inclusive_price);
	$price.find('.product-gst-inclusive-value').html(formatted_gst_inclusive_price || "");
	$price.find('.product-gst-rate-value').html(
		formatted_gst_rate ? `(${formatted_gst_rate})` : ""
	);

	const totals = [];
	if (has_entered_qty && Number.isFinite(display_rate) && display_rate > 0) {
		totals.push(`${__("Total")}: ${ikart.webshop.product_ui.format_money(display_rate * stock_qty, currency)}`);
	}
	if (has_entered_qty && Number.isFinite(gst_inclusive_price) && gst_inclusive_price > 0) {
		totals.push(`${__("Incl. GST Total")}: ${ikart.webshop.product_ui.format_money(gst_inclusive_price * stock_qty, currency)}`);
	}
	if (has_entered_qty && qty_multiplier !== 1 && stock_uom && order_uom) {
		totals.push(`${__("Stock Qty")}: ${ikart.webshop.product_ui.format_qty(stock_qty)} ${stock_uom}`);
	}

	$price.find('.product-selected-total')
		.toggleClass('hidden', !totals.length)
		.html(totals.join("<br>"));
};

ikart.webshop.product_ui.update_group_variant_purchase_state = function($scope, $button) {
	if (!$button || !$button.length) {
		return;
	}

	const item_code = $button.data('item-code');
	const in_cart = cint($button.data('in-cart')) === 1;
	const cart_qty = Number.parseFloat($button.data('cart-qty')) || 1;
	const has_price = cint($button.data('has-price')) === 1 || Boolean($button.data('formatted-price'));
	const route = $button.data('route');
	const image = $button.data('image');
	const title = $button.data('title');
	const order_uom = $button.data('order-uom') || $button.data('stock-uom') || "";
	const use_alternate_order_uom = cint($button.data('use-alternate-order-uom'));

	$scope.find('.product-item-code-value').text(item_code || "");
	if (route) {
		$scope.find('.product-link').attr('href', `/${route}`);
	}
	ikart.webshop.product_ui.update_product_image($scope, image, title, item_code);

	$scope.find('.btn-add-to-cart-list:not(.go-to-cart):not(.go-to-cart-grid)')
		.attr('data-item-code', item_code)
		.data('item-code', item_code)
		.toggleClass('hidden', in_cart); // add-to-cart shown even with no price (→ enquiry)
	$scope.find('.product-price-on-request').toggleClass('hidden', has_price);
	$scope.find('.go-to-cart, .go-to-cart-grid').toggleClass('hidden', !in_cart);
	$scope.find('.go-to-cart, .go-to-cart-grid')
		.closest('a')
		.attr('href', `/cart?highlight_item=${encodeURIComponent(item_code || "")}`);
	$scope.find('.cart-action-container').toggleClass('d-flex', in_cart);
	$scope.find('.product-qty-wrapper').toggleClass('hidden', in_cart && has_price);
	$scope.find('.product-qty-input')
		.attr('data-item-code', item_code)
		.data('item-code', item_code);
	// order_uom already falls back to the stock UOM above, so it holds the
	// unit to display whether or not an alternate UOM is in play.
	// The stepper shows the unit as a tag on the right (.imek-qty-uom) — retag it
	// for the newly selected variant, since each option can carry its own UOM
	// (e.g. option "1" is a Box, option "25" is Nos).
	$scope.find('.imek-qty-uom').text(order_uom || "");
	$scope.find('.product-uom-select').val(order_uom);
	$scope.find('.cart-indicator')
		.attr('data-item-code', item_code)
		.data('item-code', item_code)
		.text(ikart.webshop.product_ui.get_cart_indicator_text(cart_qty, order_uom, use_alternate_order_uom))
		.toggleClass('hidden', !in_cart);
};

ikart.webshop.product_ui.bind_group_variant_selection = function() {
	if (ikart.webshop.product_ui.group_variant_selection_bound) {
		return;
	}

	ikart.webshop.product_ui.group_variant_selection_bound = true;
	$('.page_content').on('click', '.product-size-option', (event) => {
		event.preventDefault();
		const $button = $(event.currentTarget);
		const $scope = $button.closest('.item-card, .list-row');
		const previous_item_code = $scope.find('.product-size-option.active').first().data('item-code');
		const next_item_code = $button.data('item-code');

		$scope.find('.product-size-option').removeClass('active').attr('aria-pressed', 'false');
		$button.addClass('active').attr('aria-pressed', 'true');
		ikart.webshop.product_ui.update_group_variant_purchase_state($scope, $button);
		if (previous_item_code && previous_item_code !== next_item_code) {
			$scope.find('.product-qty-input').val("");
		}
		ikart.webshop.product_ui.update_product_price($scope);
	});

	$('.page_content').on('input change', '.product-qty-input', (event) => {
		const $scope = $(event.currentTarget).closest('.item-card, .list-row, .product-container, .item-cart');
		ikart.webshop.product_ui.update_product_price($scope);
	});

	// Product-card qty is type-only — the +/- stepper buttons were removed, so
	// there is no step handler. The `input change` handler above still fires on
	// typing, and get_qty_for_scope() treats a blank field as qty 1.
	$('.page_content').on('change', '.product-uom-select', (event) => {
		const $select = $(event.currentTarget);
		const $selected = $select.find('option:selected');
		const $scope = $select.closest('.item-card, .list-row, .product-container, .item-cart');
		const order_uom = $select.val() || "";
		const conversion_factor = Number.parseFloat($selected.data('conversion-factor')) || 1;
		const $price = $scope.find('.product-price').first();
		const $variant = $scope.find('.product-size-option.active').first();

		$price
			.attr('data-order-uom', order_uom)
			.attr('data-conversion-factor', conversion_factor)
			.attr('data-use-alternate-order-uom', order_uom ? 1 : 0)
			.data('order-uom', order_uom)
			.data('conversion-factor', conversion_factor)
			.data('use-alternate-order-uom', order_uom ? 1 : 0);

		if ($variant.length) {
			$variant
				.attr('data-order-uom', order_uom)
				.attr('data-conversion-factor', conversion_factor)
				.attr('data-use-alternate-order-uom', order_uom ? 1 : 0)
				.data('order-uom', order_uom)
				.data('conversion-factor', conversion_factor)
				.data('use-alternate-order-uom', order_uom ? 1 : 0);
		}

		ikart.webshop.product_ui.update_product_price($scope);
	});
};

ikart.webshop.product_ui.bind_product_image_preview = function() {
	if (ikart.webshop.product_ui.product_image_preview_bound) {
		return;
	}

	ikart.webshop.product_ui.product_image_preview_bound = true;

	const ensure_preview = () => {
		let $preview = $('.product-image-preview-overlay');
		if ($preview.length) {
			return $preview;
		}

		$preview = $(`
			<div class="product-image-preview-overlay hidden" role="dialog" aria-modal="true">
				<button type="button" class="product-image-preview-close" aria-label="${ __("Close") }">
					&times;
				</button>
				<div class="product-image-preview-frame">
					<img class="product-image-preview-img" src="" alt="">
				</div>
			</div>
		`).appendTo('body');

		return $preview;
	};

	const hide_preview = () => {
		$('.product-image-preview-overlay')
			.addClass('hidden')
			.find('.product-image-preview-img')
			.attr('src', '')
			.attr('alt', '');
	};

	$('.page_content').on('click', '.product-image-preview-trigger', (event) => {
		event.preventDefault();
		const $trigger = $(event.currentTarget);
		const src = $trigger.data('image-src');
		if (!src) {
			return;
		}

		const $preview = ensure_preview();
		$preview.find('.product-image-preview-img')
			.attr('src', src)
			.attr('alt', $trigger.data('image-alt') || '');
		$preview.removeClass('hidden');
	});

	$('body').on('click', '.product-image-preview-close', hide_preview);
	// Close from any tap inside the preview, including directly on the image.
	// This gives the large image area the same dismiss behavior as the backdrop.
	$('body').on('click', '.product-image-preview-overlay', hide_preview);
	$(document).on('keydown', (event) => {
		if (event.key === 'Escape') {
			hide_preview();
		}
	});
};

ikart.webshop.product_ui.prepare_product_renderer = function(renderer, expected_preference) {
	if (renderer.preference !== expected_preference) {
		renderer.products_section.addClass("hidden");
	}

	if (!renderer.append) {
		renderer.products_section.empty();
	}

	ikart.webshop.product_ui.bind_group_variant_selection();
	ikart.webshop.product_ui.bind_product_image_preview();
};

ikart.webshop.product_ui.ProductGrid = class {
	/* Options:
		- items: Items
		- settings: Webshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not grid view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);
		ikart.webshop.product_ui.prepare_product_renderer(this, "Grid View");
		this.make();
	}

	make() {
		let me = this;
		let html = ``;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 90 ? title.substr(0, 90) + "..." : title;

			html += `<div class="item-card"><div class="card text-left">`;
			html += me.get_image_html(item, title);
			html += me.get_card_body_html(item, title, me.settings);
			html += `</div></div>`;
		});

		const product_wrapper = this.products_section[0];
		if (product_wrapper) {
			// Webshop Settings > Products per Line drives the desktop column
			// count (see --imek-products-per-line in webshop_modern.scss).
			// The value is already clamped server-side by get_products_per_line()
			// (see settings_payload in webshop/api.py) — do NOT re-validate the
			// range here, or the caps drift apart again.
			const per_line = cint(this.settings && this.settings.imek_products_per_line);
			if (per_line) {
				product_wrapper.style.setProperty("--imek-products-per-line", per_line);
			}

			if (this.append) {
				product_wrapper.insertAdjacentHTML("beforeend", html);
			} else {
				product_wrapper.innerHTML = html;
			}
			ikart.webshop.product_ui.replace_broken_product_images(product_wrapper);
		}
	}

	get_scheme_badge(item) {
		if (!item.has_scheme) {
			return "";
		}
		return `
			<span class="imek-scheme-badge" title="${ __("Offer available") }">
				<svg class="icon icon-sm"><use href="#icon-tag"></use></svg>
				${ __("Offer") }
			</span>
		`;
	}

	get_image_html(item, title) {
		let image = item.website_image || item.thumbnail;
		const fallback_text = ikart.webshop.product_ui.attr(frappe.get_abbr(title || ""));
		const scheme_badge = this.get_scheme_badge(item);

		if (image) {
			return `
				<div class="card-img-container" data-fallback-text="${ fallback_text }">
					${ scheme_badge }
					<button type="button" class="product-image-preview-trigger"
						data-image-src="${ ikart.webshop.product_ui.attr(image) }"
						data-image-alt="${ ikart.webshop.product_ui.attr(title) }">
						<img itemprop="image" class="card-img"
							src="${ ikart.webshop.product_ui.attr(image) }"
							alt="${ ikart.webshop.product_ui.attr(title) }"
							loading="lazy" decoding="async">
					</button>
				</div>
			`;
		} else {
			return `
				<div class="card-img-container" data-fallback-text="${ fallback_text }">
					${ scheme_badge }
					<div class="card-img-top no-image">
						${ fallback_text }
					</div>
				</div>
			`;
		}
	}

	get_card_body_html(item, title, settings) {
		// Size options and price live in the add-to-cart popup now, not on the
		// card face. They stay in the card's DOM, hidden, because they are the
		// data source the popup reads and the state the rest of the app already
		// talks to -- bind_group_variant_selection(), update_product_price() and
		// add_to_cart_from_button() all look for .product-size-option and
		// .product-price inside the card. Clicking an option in the popup
		// forwards to the hidden one here, so that machinery is untouched.
		const price_html = this.get_price_html(item);
		const action_html = this.get_primary_button(item, settings);

		let body_html = `
			<div class="card-body text-left card-body-flex" style="width:100%">
				<div class="imek-card-titlerow">
		`;
		body_html += this.get_title(item, title);

		// get floating elements -- both are position:absolute against the card
		// itself (see .like-action / .cart-indicator), so where they sit in the
		// DOM has no effect on where they render
		if (!item.has_variants) {
			if (settings.enable_wishlist) {
				body_html += this.get_wishlist_icon(item);
			}
			if (settings.enabled) {
				body_html += this.get_cart_indicator(item);
			}
		}
		body_html += `</div>`; // imek-card-titlerow

		// The cart action sits beside the BRAND, not the title: a title can run
		// to two lines, and a button chasing it up and down between a one-line
		// and a two-line title lined nothing up. The brand line is always one
		// line, so anchoring there keeps the button at the same height on every
		// card. Variant cards are the exception -- their action is a full-width
		// "Explore" link (below, unchanged), which would look wrong squeezed
		// next to the brand.
		body_html += `<div class="imek-card-brandrow">`;
		body_html += ikart.webshop.product_ui.get_brand_html(item);
		if (!item.has_variants) {
			body_html += action_html;
		}
		body_html += `</div>`; // imek-card-brandrow

		body_html += `
			<div class="imek-card-buydata" hidden>
				${ this.get_group_variant_buttons(item) }
				${ price_html }
			</div>
		`;

		body_html += this.get_stock_availability(item, settings);
		if (item.has_variants) {
			body_html += action_html;
		}
		body_html += `</div>`; // card-body

		return body_html;
	}

	get_title(item, title) {
		let title_html = `
			<a class="product-link" href="/${ item.route || '#' }">
				<div class="product-title" itemprop="name">
					${ title || '' }
				</div>
			</a>
		`;
		return title_html;
	}

	get_group_variant_buttons(item) {
		if (!item.group_variants || !item.group_variants.length) {
			return ``;
		}

		const buttons = item.group_variants.map(variant => `
			<button type="button"
				class="btn btn-xs btn-default product-size-option ${ variant.is_active ? 'active' : '' }"
				aria-pressed="${ variant.is_active ? 'true' : 'false' }"
				${ ikart.webshop.product_ui.get_group_variant_attrs(variant) }>
				${ variant.label }
			</button>
		`).join("");

		return `
			<div class="product-size-options mt-2" aria-label="${ __("Available sizes") }">
				${ buttons }
			</div>
		`;
	}

	get_wishlist_icon(item) {
		const attr = ikart.webshop.product_ui.attr;
		let icon_class = item.wished ? "wished" : "not-wished";
		return `
			<button type="button" class="like-action ${ item.wished ? "like-action-wished" : ''}"
				data-item-code="${ attr(item.item_code) }"
				aria-label="${ __("Toggle wishlist") }"
				aria-pressed="${ item.wished ? 'true' : 'false' }">
				<svg class="icon sm" aria-hidden="true">
					<use class="${ icon_class } wish-icon" href="#icon-heart"></use>
				</svg>
			</button>
		`;
	}

	get_cart_indicator(item) {
		const attr = ikart.webshop.product_ui.attr;
		return `
			<div class="cart-indicator ${item.in_cart ? '' : 'hidden'}" data-item-code="${ attr(item.item_code) }">
				${ ikart.webshop.product_ui.get_cart_indicator_text(
					item.cart_qty || 1,
					item.order_uom,
					item.use_alternate_order_uom
				) }
			</div>
		`;
	}

	get_price_html(item) {
		let price_html = `
			<div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer"
				data-display-rate="${ ikart.webshop.product_ui.attr(item.display_rate || '') }"
				data-currency="${ ikart.webshop.product_ui.attr(item.currency || '') }"
				data-formatted-price="${ ikart.webshop.product_ui.attr(item.formatted_price || '') }"
				data-gst-inclusive-price="${ ikart.webshop.product_ui.attr(item.gst_inclusive_price || '') }"
				data-formatted-gst-inclusive-price="${ ikart.webshop.product_ui.attr(item.formatted_gst_inclusive_price || '') }"
				data-formatted-gst-rate="${ ikart.webshop.product_ui.attr(item.formatted_gst_rate || '') }"
				data-gst-label="${ ikart.webshop.product_ui.attr(item.gst_label || __('GST')) }"
				data-stock-uom="${ ikart.webshop.product_ui.attr(item.stock_uom || item.uom || '') }"
				data-order-uom="${ ikart.webshop.product_ui.attr(item.order_uom || item.stock_uom || item.uom || '') }"
				data-conversion-factor="${ ikart.webshop.product_ui.attr(item.conversion_factor || 1) }"
				data-use-alternate-order-uom="${ item.use_alternate_order_uom ? 1 : 0 }">
				<span class="product-unit-price">${ item.formatted_price || (item.has_variants ? '' : __("Price on request")) }</span>
				<small class="formatted-price product-stock-uom ml-1">${ item.formatted_price && (item.stock_uom || item.uom) ? `/ ${ item.stock_uom || item.uom }` : "" }</small>
		`;

		if (item.formatted_mrp) {
			price_html += `
				<small class="striked-price">
					<s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
				</small>
				<small class="ml-1 product-info-green">
					${ item.discount } ${ __("OFF") }
				</small>
			`;
		}
		price_html += `
			<div class="small text-muted mt-1 product-gst-inclusive-row ${ item.formatted_gst_inclusive_price ? '' : 'hidden' }">
				${ __("Incl. GST") }
				<span class="product-gst-rate-value">${ item.formatted_gst_rate ? `(${ item.formatted_gst_rate })` : "" }</span>
				:
				<strong class="product-gst-inclusive-value">${ item.formatted_gst_inclusive_price || '' }</strong>
			</div>
		`;
		price_html += `<div class="small product-selected-total mt-1 hidden"></div>`;
		price_html += `</div>`;
		return price_html;
	}

	get_stock_availability(item, settings) {
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
					<span class="out-of-stock mb-2 mt-1" style="color: var(--primary-color)">
						${ __("Available on backorder") }
					</span>
				`;
			} else if (!item.in_stock) {
				return `
					<span class="out-of-stock mb-2 mt-1">
						${ __("Out of stock") }
					</span>
				`;
			}
		}

		return ``;
	}

	get_quantity_selector(item) {
		// Same marketplace-style stepper as the list view (see list.js) — −/+
		// buttons with the UOM as a right-side tag, no "Qty" title. Keeps the
		// .product-qty-input / .product-uom-select hooks so the cart is unchanged.
		return ikart.webshop.product_ui.get_marketplace_qty_selector(item, "mt-2");
	}

	get_primary_button(item, settings) {
		const attr = ikart.webshop.product_ui.attr;
		const has_price = Boolean(item.formatted_price);
		if (item.has_variants) {
			return `
				<a href="/${ item.route || '#' }">
					<div class="btn btn-sm btn-explore-variants w-100 mt-4">
						${ __("Explore") }
					</div>
				</a>
			`;
		} else if (settings.enabled && (settings.allow_items_not_in_stock || item.in_stock)) {
			// d-flex on first paint when the item is ALREADY in the cart. Every
			// other path that reaches this state adds it — add-to-cart
			// (shopping_cart.js), the variant switch below, and list.js's own
			// first paint — so leaving it off here made an item that was in the
			// cart at page load render a full-width "Go to Cart", while the same
			// item added a moment later rendered the narrow flex-row version.
			return `
				<div class="cart-action-container grid-cart-action${ item.in_cart ? ' d-flex' : '' }">
					<div class="product-purchase-row">
						<button type="button" id="${ item.name }" class="btn
							btn-sm btn-primary btn-add-to-cart-list product-purchase-button
							${ item.in_cart ? 'hidden' : '' }"
							data-item-code="${ attr(item.item_code) }"
							aria-label="${ settings.enable_checkout ? __("Add to Cart") :  __("Add to Quote") }">
							<span class="cart-action-icon">
								<svg class="icon icon-md" aria-hidden="true">
									<use href="#icon-shopping-cart"></use>
								</svg>
							</span>
						</button>

						<span class="text-muted small product-price-on-request ${ has_price ? 'hidden' : '' }">
							${ __("Price on request") }
						</span>
					</div>

					<a href="/cart?highlight_item=${ encodeURIComponent(item.item_code || "") }">
						<div id="${ item.name }" class="btn
							btn-sm btn-primary btn-add-to-cart-list
							w-100 mt-4 go-to-cart-grid
							${ item.in_cart ? '' : 'hidden' }"
							data-item-code="${ attr(item.item_code) }">
							${ settings.enable_checkout ? __("Go to Cart") :  __("Go to Quote") }
						</div>
					</a>
				</div>
			`;
		} else {
			return ``;
		}
	}
};
